import {
  IonContent,
  IonHeader,
  IonItem,
  IonItemDivider,
  IonPage,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import "./Tab3.css";

const Tab3: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>このサイトについて</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonItemDivider>概要</IonItemDivider>
        <IonItem>
          <IonText>
            このサイトはAAを放置少女内で使用できるように変換できるツールを置いています。
            <br />
            主に、仕様変更によって使用できなくなったAAを、ある程度使用できるように変換できます。
            <br />
            <IonText color="danger">
              あらかじめ改行されているAAのみ対応しています。
            </IonText>
            <br />
            その他、AAの保存やスペースの最適化、文字数オーバーの警告表示もできます。
            <br />
            ブラウザ上ではズレているように見えますが、スペースごとそのままチャット欄へ貼り付けて下さい。
          </IonText>
        </IonItem>
        <br />
        <IonItemDivider>免責事項</IonItemDivider>
        <IonItem>
          <IonText>
            AAによっては、ツールでの変換だけではズレが発生するものもあります。
            <br />
            その場合は手動で修正していただくなり、各自の自己責任でのご使用をお願いします。
            <br />
            他、
            <IonText color="danger">
              このツールの使用による一切の責任は負いかねます。
            </IonText>
          </IonText>
        </IonItem>
        <br />
        <IonItemDivider>仕様説明</IonItemDivider>
        <IonItem>
          <IonText>
            放置少女のチャットは、全角・半角問わず120文字まで入力可能です。そのため、連続された半角スペースを、全角スペースに変換しています。
            <br />
            チャットでは、30byte(半角1文字が1byte、全角1文字が2byte)で改行された表示になります。そのため、変換後に30byteを超える場合は警告を出しています。末尾の文字や、支障の無いスペースを削除してから再度変換して下さい。
            <br />
            記号によっては、旧仕様から横幅が相対的に変更されているものもあります。投稿前に別鯖の1人同盟チャットや同チャ・個チャなどで確認してください。
          </IonText>
        </IonItem>
      </IonContent>
    </IonPage>
  );
};

export default Tab3;
